import { ArrowPathIcon, ClockIcon } from "@heroicons/react/24/outline";
import { STATUS_PILL_CLASS } from "../constants";
import { formatDateTimeLabel, statusDisplayLabel } from "../utils";

export default function EditionsTable({
  isLoading,
  filteredEditions,
  emptyMessage,
  onOpenPreview,
  onUpdateSingle,
  updatingEditionId,
  disableUpdates = false,
}) {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-100" aria-busy={isLoading}>
        <thead className="bg-gray-50 text-left text-sm font-semibold text-gray-500">
          <tr>
            <th className="px-6 py-4">Edition Name</th>
            <th className="px-6 py-4">Status</th>
            <th className="px-6 py-4">Last Updated</th>
            <th className="px-6 py-4">Insert Time</th>
            <th className="px-6 py-4">Comments</th>
            <th className="px-6 py-4 text-right">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {isLoading ? (
            <tr>
              <td className="px-6 py-6 text-sm text-gray-500" colSpan={6}>
                Loading editions...
              </td>
            </tr>
          ) : null}
          {!isLoading && filteredEditions.length === 0 ? (
            <tr>
              <td className="px-6 py-6 text-sm text-gray-500" colSpan={6}>
                {emptyMessage || "No editions found for current filters."}
              </td>
            </tr>
          ) : null}
          {!isLoading &&
            filteredEditions.map((edition) => (
            <tr
              key={edition.id}
              className={`text-sm text-gray-700 ${
                updatingEditionId === edition.id ? "bg-cyan-50" : ""
              }`}
            >
              <td className="px-6 py-4 font-semibold text-gray-900">{edition.name}</td>
              <td className="px-6 py-4">
                <span
                  className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${
                    STATUS_PILL_CLASS[statusDisplayLabel(edition.status, edition.isNotPublished)] ||
                    STATUS_PILL_CLASS[edition.status]
                  }`}
                >
                  {statusDisplayLabel(edition.status, edition.isNotPublished)}
                </span>
              </td>
              <td className="px-6 py-4">{formatDateTimeLabel(edition.updatedAt)}</td>
              <td className="px-6 py-4">
                {edition.editionInsertTimeFormatted || `${Math.max(0, Number(edition.editionInsertTimeMs) || 0)} ms`}
              </td>
              <td className="px-6 py-4 text-gray-500">{edition.comments}</td>
              <td className="px-6 py-4 text-right">
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    className="inline-flex items-center gap-2 rounded-xl border border-gray-300 bg-white px-3 py-2 font-semibold text-gray-700 hover:bg-gray-50"
                    onClick={() => onOpenPreview(edition)}
                  >
                    PDF Preview
                  </button>
                  <button
                    type="button"
                    className="inline-flex items-center gap-2 rounded-xl border border-gray-300 bg-white px-3 py-2 font-semibold text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
                    onClick={() => onUpdateSingle(edition.id)}
                    title={
                      disableUpdates
                        ? "Select a single day to update editions"
                        : updatingEditionId && updatingEditionId !== edition.id
                          ? "Another edition is updating"
                          : undefined
                    }
                    disabled={disableUpdates || updatingEditionId != null}
                  >
                    {updatingEditionId === edition.id ? (
                      <ClockIcon className="h-4 w-4 animate-spin" />
                    ) : (
                      <ArrowPathIcon className="h-4 w-4" />
                    )}
                    {updatingEditionId === edition.id ? "Updating..." : "Update"}
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
